import React from "react";
import styles from "../../../../styles/pages/articles/ArticleFooter.module.scss";

export default function ArticleFooter({
  year = new Date().getFullYear(),
  owner = "Muntaza",
  subtitle = "· Copyright reserved.",
  links = [
    { label: "Linkedin", href: "https://www.linkedin.com/in/munti/" },
    { label: "GitHub", href: "#" },
    { label: "Contact", href: "#" },
  ],
}) {
  return (
    <footer className={styles.footer}>
      <div className={styles.container}>
        <div className={styles.left}>
          <span className={styles.dot} />
          <span>© {year} {owner}</span>
          <span className={styles.muted}>{subtitle}</span>
        </div>

        <div className={styles.right}>
          {links.map((l) => (
            <a key={l.label} className={styles.chip} href={l.href}>
              {l.label}
            </a>
          ))}
        </div>
      </div>
    </footer>
  );
}
